module.exports = __webpack_public_path__ + "img/south-africa.8dc48856.svg";